<template>
  <LineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import LineChart from '@/components/cards/models/LineChart';
import proprietaryModel from '@/mixins/proprietary-model';
import { ENTITIES, SAC_STATUS_FIELDS } from '@/services/charts-service';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import cardsModel from '@/mixins/cards-model';
import { sortSeries } from '@/utils/sorting';

export default {
  name: 'SacOperatorsTimeSeries',
  components: {
    LineChart,
  },
  mixins: [
    proprietaryModel,
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },

  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      categories: [],
    };
  },
  computed: {
    cardOptions() {
      return {
        chart: {
          type: 'area',
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          area: {
            stacking: 'percent',
            lineWidth: 1,
            fillOpacity: 0.5,
            marker: {
              enabled: false,
            },
          },
        },
        xAxis: {
          categories: this.categories,
        },
        yAxis: {
          points: this.points,
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.y}</b> ({point.percentage:.1f}%)<br/>',
        },
      };
    },
    series() {
      if (!this.rawSeries && !this.rawSeries.length) {
        return [];
      }

      const organizedSeries = this.rawSeries.map(serie => {
        return {
          name: serie.name || this.$t('DataManagement.undefined'),
          data: serie.data,
        };
      });

      const sortedSeries = sortSeries(organizedSeries);
      return sortedSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.categories = [];
      this.rawSeries = [];

      this.getChartsService({
        itemId: this.itemId,
        method: 'getTimeSeries',
        entity: ENTITIES.SAC_STATUS,
        params: {
          grouping: [
            SAC_STATUS_FIELDS.userName,
          ],
          label: 'Atendimentos',
          sortFields: [SAC_STATUS_FIELDS.annotateAtDate],
          datePortion: this.getDatePortion(options),
        },
      })
        .then(({ axes, points }) => {
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }

          // FIXME STD-379 - service returns a serie of zeros when has no data
          if (!axes.find(({ label }) => label === SAC_STATUS_FIELDS.userName)) {
            return;
          }

          const rawCategories = (axes || [])[0]?.values;
          this.categories = this.formattedCategories(rawCategories);
          this.rawSeries = points;
        })
        .catch((err) => {
          this.requestStatus = 'error';
          console.error(err);
        });
    },
    formattedCategories(categories) {
      return this.formattedCategoriesForQuarter(categories);
    },
  },
};
</script>

